module.exports = __webpack_public_path__ + "static/media/Cover.4b6471b7.png";